module.exports = __webpack_public_path__ + "img/4g.2c9ba8ab.svg";